export const getColor = (status) => {
  if (!status) return "bg-label-secondary";

  const statusMapping = {
    approved: "bg-label-success",
    pending: "bg-label-orange",
    rejected: "bg-label-danger",
    active: "bg-label-green",
    expired: "bg-label-danger",
    notamember: "bg-light",
    inactive: "bg-label-danger",
    invited:"bg-label-orange",
    cash: "bg-label-blue",
    cashin: "bg-label-info",
    cashout: "bg-label-info",
    card: "bg-label-blue",
    upi: "bg-label-info",
    online: "bg-label-green",
    cod: "bg-label-blue",
    complete: "bg-label-info",
    other: "bg-label-success",
    unpaid: "bg-label-warning",
    paid: "bg-label-green",
    main: "bg-label-violetStock",
    sub:"bg-label-lightSub",
    hub:"bg-label-lightHubStock"
  };

  return statusMapping[status.toLowerCase()] || "bg-label-secondary";
};
export const getTextColor = (stype) => {
  const mapping = {
    main: "text-main",
    sub: "text-sub",
    hub: "text-hub",
  };

  return mapping[stype?.toLowerCase()] || "text-secondary";
};


export const getName = (status) => {
  if (!status) return "No Status";

  const statusMapping = {
    active: "Active",
    inactive: "InActive",
    invited: "Invited",
    approved: "Approved",
    pending: "Pending",
    rejected: "Rejected",
    expired: "Expired",
    notamember: "Not a Member",
    cash: "Cash",
    cashin: "Cash In",
    cashout: "Cash Out",
    card: "Card",
    upi: "UPI",
    online: "Online",
    cod: "COD",
    complete: "Complete",
    unpaid: "Unpaid",
    paid: "Paid",
    other: "Other",
  };

  return statusMapping[status.toLowerCase()] || 
         status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

export const formatDate = (date) => {
  if (!date) return "";

  return new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Hello World
export const capitalizeText = (text) => {
  if (!text) return "";
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const onlyCapitalizeFirst = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const roundToNearest = (value) => {
  if (value === undefined || value === null || isNaN(value)) {
    return 0;
  }
  return Math.round(value);
};

export const stopEventPropagation = (e) => {
  e.stopPropagation();
};

// Replaces multiple consecutive spaces with a single space
export const cleanSpaces = (text) => {
  return text.replace(/\s+/g, " ").trimStart();
};

// Function to format numeric input (restricts to max 12 integer digits and 2 decimal places)
export const formatNumericInput = (
  value,
  maxIntegerDigits = 12,
  maxDecimalDigits = 2
) => {
  let numericValue = value.replace(/[^0-9.]/g, "");

  const decimalCount = (numericValue.match(/\./g) || []).length;
  if (decimalCount > 1) {
    return "";
  }

  let [integerPart, decimalPart] = numericValue.split(".");

  if (integerPart.length > maxIntegerDigits) {
    integerPart = integerPart.slice(0, maxIntegerDigits);
  }

  if (decimalPart && decimalPart.length > maxDecimalDigits) {
    decimalPart = decimalPart.slice(0, maxDecimalDigits);
  }

  return decimalPart !== undefined
    ? `${integerPart}.${decimalPart}`
    : integerPart;
};

export const removeWhitespace = (value) => value.replace(/\s/g, "");
export const removeStartspace = (value) => value.replace(/^\s+/, "");
export const allowOnlyNumbers = (value) => {
  return value.replace(/\D/g, "");
};
